'use strict';

var StrategyGroupController = function StrategyGroupController($scope, elementService, strategyRecordService, strategyConstants) {
  function changeSelectedRow(selectedRow, collectionName) {
    $scope.groupShownInStatementBox = $scope.strategyGroup;
    elementService.selectRow($scope.strategyGroup, selectedRow, $scope.strategyGroup[collectionName], collectionName);
    $scope.$emit('strategy-custom:selectedLevelChanged', $scope.selectedLevel.value.domain, $scope.flowType);
  }
  function selectDefaultRow() {
    changeSelectedRow($scope.strategyGroup[$scope.defaultCollection][$scope.strategyGroup.actions.length - 1], $scope.defaultCollection);
  }
  function prepareDefaultAction() {
    if ($scope.activeEntityType === strategyConstants.PANEL_TYPE.ALERTS) {
      var alertActionParams = strategyRecordService.getDefaultActionForLevel('action', $scope.selectedLevel.value.domain, $scope.activeEntityType);
      return elementService.createAction(alertActionParams);
    }
    return elementService.createAction();
  }
  function resetStrategyGroup() {
    var newCondition = elementService.createCondition();
    $scope.strategyGroup.conditions.length = 0;
    $scope.strategyGroup.conditions.push(newCondition);
    var newAction = prepareDefaultAction();
    $scope.strategyGroup.actions.length = 0;
    $scope.strategyGroup.actions.push(newAction);
    selectDefaultRow();
  }
  function isSingleEmptyAction(actions) {
    return actions.length === 1 && actions[0].isEmpty();
  }
  function verifyElementsExist() {
    $scope.strategyGroup.conditions = $scope.strategyGroup.conditions || [];
    $scope.strategyGroup.actions = $scope.strategyGroup.actions || [];
    if (!$scope.strategyGroup.conditions.length) {
      var newCondition = elementService.createCondition();
      $scope.strategyGroup.conditions.push(newCondition);
    }
    if (!$scope.strategyGroup.actions.length) {
      var newAction = elementService.createAction();
      $scope.strategyGroup.actions.push(newAction);
    } else if ($scope.activeEntityType === strategyConstants.PANEL_TYPE.ALERTS && isSingleEmptyAction($scope.strategyGroup.actions)) {
      $scope.strategyGroup.actions[0] = prepareDefaultAction();
    }
    selectDefaultRow();
  }
  $scope.isRowSelected = function (row) {
    return elementService.isRowSelected(row);
  };
  $scope.selectConditionHandler = function (selectedRow, collectionName) {
    changeSelectedRow(selectedRow, collectionName);
    $scope.onSelectStrategyCondition($scope.strategyGroup);
  };
  $scope.selectedLevelChanged = function () {
    if ($scope.strategyGroup.level === $scope.selectedLevel.value.domain) {
      verifyElementsExist();
    } else {
      $scope.strategyGroup.level = $scope.selectedLevel.value.domain;
      resetStrategyGroup();
    }
    $scope.$emit('strategy-custom:selectedLevelChanged', $scope.selectedLevel.value.domain, $scope.flowType);
  };
};
StrategyGroupController.$inject = ['$scope', 'StrategyElementService', 'StrategyRecordService', 'StrategyConstants'];
module.exports = StrategyGroupController;